import {FieldErrors} from "react-hook-form";

interface ICollectLeadFormFieldErrorPathsResult {
    errorFields: string[];
    errorMessages: string[];
}

/**
 * React Hook Form metadata rather than nested fields. `ref` holds the DOM node, and React hangs a
 * cyclic fiber off it — recursing into it would blow the stack instead of collecting a field name.
 */
const fieldErrorMetaKeys = new Set(["ref", "types"]);

/**
 * Flat `field path -> message` map of the currently invalid fields. Used to tell one validation state
 * from another - react-hook-form mutates `formState.errors` in place, so its identity says nothing.
 */
export const getLeadFormFieldErrorsMap = (errors: FieldErrors): Record<string, string> => {
    const {errorFields, errorMessages} = collectLeadFormFieldErrorPaths(errors);

    return errorFields.reduce<Record<string, string>>((acc, fieldName, index) => {
        acc[fieldName] = errorMessages[index] ?? "";

        return acc;
    }, {});
};

export const collectLeadFormFieldErrorPaths = (errors: FieldErrors, prefix = ""): ICollectLeadFormFieldErrorPathsResult => {
    const errorFields: string[] = [];
    const errorMessages: string[] = [];

    for (const key of Object.keys(errors)) {
        const fieldError = errors[key];
        const path = prefix ? `${prefix}.${key}` : key;

        if (!fieldError || typeof fieldError !== "object" || fieldErrorMetaKeys.has(key)) {
            continue;
        }

        if ("message" in fieldError && typeof fieldError.message === "string" && fieldError.message) {
            errorFields.push(path);
            errorMessages.push(fieldError.message);
            continue;
        }

        const nested = collectLeadFormFieldErrorPaths(fieldError as FieldErrors, path);
        errorFields.push(...nested.errorFields);
        errorMessages.push(...nested.errorMessages);
    }

    return {errorFields, errorMessages};
};
import {FieldErrors} from "react-hook-form";

interface ICollectLeadFormFieldErrorPathsResult {
    errorFields: string[];
    errorMessages: string[];
}

/**
 * React Hook Form metadata rather than nested fields. `ref` holds the DOM node, and React hangs a
 * cyclic fiber off it — recursing into it would blow the stack instead of collecting a field name.
 */
const fieldErrorMetaKeys = new Set(["ref", "types"]);

/**
 * Flat `field path -> message` map of the currently invalid fields. Used to tell one validation state
 * from another - react-hook-form mutates `formState.errors` in place, so its identity says nothing.
 */
export const getLeadFormFieldErrorsMap = (errors: FieldErrors): Record<string, string> => {
    const {errorFields, errorMessages} = collectLeadFormFieldErrorPaths(errors);

    return errorFields.reduce<Record<string, string>>((acc, fieldName, index) => {
        acc[fieldName] = errorMessages[index] ?? "";

        return acc;
    }, {});
};

export const collectLeadFormFieldErrorPaths = (errors: FieldErrors, prefix = ""): ICollectLeadFormFieldErrorPathsResult => {
    const errorFields: string[] = [];
    const errorMessages: string[] = [];

    for (const key of Object.keys(errors)) {
        const fieldError = errors[key];
        const path = prefix ? `${prefix}.${key}` : key;

        if (!fieldError || typeof fieldError !== "object" || fieldErrorMetaKeys.has(key)) {
            continue;
        }

        if ("message" in fieldError && typeof fieldError.message === "string" && fieldError.message) {
            errorFields.push(path);
            errorMessages.push(fieldError.message);
            continue;
        }

        const nested = collectLeadFormFieldErrorPaths(fieldError as FieldErrors, path);
        errorFields.push(...nested.errorFields);
        errorMessages.push(...nested.errorMessages);
    }

    return {errorFields, errorMessages};
};
